<template>
  <b-col
    md="6"
    lg="4"
    sm="12"
    class="mb-5 icon-item"
  >
    <img
      src="@/assets/images/bajavoluntaria/formato-inscripcion.png"
      alt="Acta de nacimiento"
      class="img-icon"
    >
    <h4 class="font-weight-bold color-p">
      {{ index }}. {{ documento.nombre }}
    </h4>
    <p class="description">
      {{ documento.descripcion }}
    </p>
    <b-button
      v-if="documento.formato"
      variant="success"
      @click="showFormato"
    >
      Descargar Formato
    </b-button>
  </b-col>
</template>

<script>
import { BButton, BCol } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BCol,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    documento: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    showFormato() {
      window.open(this.documento.formato, '_blank')
    },
  },
}
</script>

<style scope>
.description {
  word-break: normal;
}
</style>
